import common from './common.lang';
import navigation from './navigation.lang';
import forms from './forms.lang';
import validation from './validation.lang';
import subscribe from './subscribe.lang';
import components from './components.lang';

export default {
    common,
    navigation,
    forms,
    validation,
    subscribe,
    components,
};
